import { SET_SELECTED_EVENT, SET_TRIP_EVENTS, SET_EVENTS, SET_CVENT_URL } from '../actions/events';

const initialState = { selectedEvent: null, tripEvents: [] };

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_EVENT:
      return {
        ...state,
        selectedEvent: action.payload,
      };
    case SET_TRIP_EVENTS:
      return {
        ...state,
        tripEvents: action.payload.events,
      };
    case SET_EVENTS:
      return {
        ...state,
        tezEvent: action.event,
      };
    case SET_CVENT_URL:
      return {
        ...state,
        cventUrl: action.cventUrl,
      };
    default:
      return state;
  }
};
